import { render, staticRenderFns } from "./StepPagination.vue?vue&type=template&id=3d54b2fe"
import script from "./StepPagination.vue?vue&type=script&lang=js"
export * from "./StepPagination.vue?vue&type=script&lang=js"
import style0 from "./StepPagination.vue?vue&type=style&index=0&id=3d54b2fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports